import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'invite-actions',
    templateUrl: './invite-actions.component.html',
    standalone: false
})
export class InviteActionsComponent {
  @Input() id: string;
  @Input() canResend: boolean = true;
  @Input() canCancel: boolean = true;
  @Output() resend = new EventEmitter<string>();
  @Output() cancel = new EventEmitter<string>();
}
